import { Box } from '@mui/material';
import { ReactNode } from 'react';

const RoleBusinessWrapper = ({ children }: { children: ReactNode }) => (
  <Box sx={{ width: '100%', padding: '0 80px' }}>{children}</Box>
);

export default RoleBusinessWrapper;
